import {Fragment} from "react";
import {Grid, Typography} from "@mui/material";

export const WordPressCalculatorResultLTL = ({
                                                 lng,
                                                 redirectToApp,
                                                 palletDetail,
                                                 calculatedResult
                                             }) => {

    console.log('[WordPressCalculatorResultLTL] calculatedResult', calculatedResult);

    if (!calculatedResult) {
        return (
            <Fragment>
                <Grid size={{xs: 12}}>
                    <Typography>
                        {lng === 'cn' ? '根据您当前的选择，系统无法实时计算。' : "Based on the selections you've made, the system cannot calculate in real time."}
                    </Typography>
                </Grid>
                {redirectToApp()}
            </Fragment>
        )
    }

    return (
        <Fragment>
            <Grid size={{xs: 12}}>
                <Grid container spacing={2}>
                    <Grid size={{xs: 12}}>
                        <Typography sx={{fontWeight: '600'}}>
                            {lng === 'cn' ? '托盘详情' : 'Pallet Details'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 2}}>
                        <Typography>
                            {lng === 'cn' ? '长度' : 'Length'}: {palletDetail?.length} {lng === 'cn' ? '英寸' : 'in'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 2}}>
                        <Typography>
                            {lng === 'cn' ? '宽度' : 'Width'}: {palletDetail?.width} {lng === 'cn' ? '英寸' : 'in'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 2}}>
                        <Typography>
                            {lng === 'cn' ? '高度' : 'Height'}: {palletDetail?.height} {lng === 'cn' ? '英寸' : 'in'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 2}}>
                        <Typography>
                            {lng === 'cn' ? '重量' : 'Weight'}: {palletDetail?.weight} {lng === 'cn' ? '磅' : 'lb'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 2}}>
                        <Typography>
                            {lng === 'cn' ? '线性比例' : 'Linear Ratio'}: {palletDetail?.linearRatio}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 2}}>
                        <Typography>
                            {lng === 'cn' ? '数量' : 'Quantity'}: {palletDetail?.quantity}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 12}}>
                        <Typography sx={{fontWeight: '600'}}>
                            {lng === 'cn' ? '计算结果' : 'Calculated Result'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography>
                            {lng === 'cn' ? '总体积' : 'Total Volume'}: {calculatedResult?.volumeWeight?.totalVolumeInch} {lng === 'cn' ? '立方英尺' : 'ft\u00B3'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography>
                            {lng === 'cn' ? '总重量' : 'Total Weight'}: {calculatedResult?.volumeWeight?.totalWeightLB} {lng === 'cn' ? '磅' : 'lb'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography>
                            {lng === 'cn' ? '总体积重' : 'Total Volume Weight'}: {calculatedResult?.volumeWeight?.totalVolumeWeightLB} {lng === 'cn' ? '立方英尺·磅' : 'ft\u00B3·lb'}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 6}}>
                        <Typography>
                            {lng === 'cn' ? '货运等级' : 'Fright Class'}: {calculatedResult?.freightClass?.result}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            {
                redirectToApp()
            }
        </Fragment>
    )
}